import { FC } from 'app/FunctionalComponent'
import React from 'react'

export const FieldsetLegend: FC = (props: { children: React.ReactNode }) => {
	return <legend>{props.children}</legend>
}
